module.exports = __webpack_public_path__ + "static/media/thought-services-1-292x300.7118a359.png";